// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAndDeleteAction_wrapper__zpNvq","deleteButton":"EditAndDeleteAction_deleteButton__7-EzV"};